"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDiscretePropertySelector = void 0;
var react_1 = require("react");
var property_1 = require("@promaster-sdk/property");
function useDiscretePropertySelector(hookOptionsLoose) {
    var hookOptions = fillOptionsWithDefualts(hookOptionsLoose);
    var propertyValueSet = hookOptions.propertyValueSet, propertyName = hookOptions.propertyName, onValueChange = hookOptions.onValueChange, disabled = hookOptions.disabled, valueComparer = hookOptions.valueComparer, showCodes = hookOptions.showCodes, items = hookOptions.items, sortValidFirst = hookOptions.sortValidFirst, falseItemIndex = hookOptions.falseItemIndex, trueItemIndex = hookOptions.trueItemIndex, getUndefinedValueItem = hookOptions.getUndefinedValueItem, itemComparer = hookOptions.itemComparer, getItemValue = hookOptions.getItemValue, getItemFilter = hookOptions.getItemFilter;
    var _a = getSelectableItems(propertyName, propertyValueSet, items, getUndefinedValueItem, sortValidFirst, valueComparer, itemComparer, getItemValue, getItemFilter), selectedItem = _a[0], selectableItems = _a[1];
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var falseItem = items[falseItemIndex];
    var trueItem = items[trueItemIndex];
    var isTrueItem = selectedItem === trueItem;
    return {
        selectedItem: selectedItem,
        disabled: disabled,
        getItemLabel: function (text, item) {
            return getItemLabel(text, getItemValue(item), isValueItemValid(propertyName, propertyValueSet, getItemFilter(item), getItemValue(item), valueComparer), showCodes);
        },
        getItemValue: function (item) { return getItemValueAsString(getItemValue(item)); },
        getItemToolTip: function (item) { return getItemToolTip(hookOptions, getItemFilter(item), getItemValue(item)); },
        isOpen: isOpen,
        isTrueItem: isTrueItem,
        isItemValid: function (item) {
            return isValueItemValid(propertyName, propertyValueSet, getItemFilter(item), getItemValue(item), valueComparer);
        },
        getDropdownToggleButtonProps: function () { return ({
            disabled: disabled,
            title: getItemToolTip(hookOptions, getItemFilter(selectedItem), getItemValue(selectedItem)),
            onClick: function () { return setIsOpen(!isOpen); },
        }); },
        getDropdownListItemProps: function (item) {
            var itemValue = getItemValue(item);
            var itemFilter = getItemFilter(item);
            return {
                title: getItemToolTip(hookOptions, itemFilter, itemValue),
                onClick: function () {
                    _doOnChange(getItemValueAsString(itemValue), onValueChange);
                    setIsOpen(false);
                },
            };
        },
        getSelectProps: function () {
            var itemValue = getItemValue(selectedItem);
            var itemFilter = getItemFilter(selectedItem);
            return {
                disabled: disabled,
                value: getItemValueAsString(itemValue),
                title: getItemToolTip(hookOptions, itemFilter, itemValue),
                onChange: function (event) {
                    _doOnChange(event.target.value, onValueChange);
                },
            };
        },
        getSelectOptionProps: function (item) {
            var itemValue = getItemValue(item);
            var itemFilter = getItemFilter(item);
            return {
                value: getItemValueAsString(itemValue),
                title: getItemToolTip(hookOptions, itemFilter, itemValue),
            };
        },
        getRadioItemProps: function (item) {
            var itemValue = getItemValue(item);
            return {
                onClick: function () { return _doOnChange(getItemValueAsString(itemValue), onValueChange); },
            };
        },
        getCheckboxDivProps: function () { return ({
            onClick: function () { return onValueChange(isTrueItem ? getItemValue(falseItem) : getItemValue(trueItem)); },
        }); },
        items: selectableItems,
    };
}
exports.useDiscretePropertySelector = useDiscretePropertySelector;
function getSelectableItems(propertyName, propertyValueSet, items, getUndefinedValueItem, sortValidFirst, valueComparer, itemComparer, getItemValue, getItemFilter) {
    // Convert value items to options
    var sortedItems = __spreadArray([], items).sort(function (a, b) {
        if (sortValidFirst) {
            var aValid = isValueItemValid(propertyName, propertyValueSet, getItemFilter(a), getItemValue(a), valueComparer);
            var bValid = isValueItemValid(propertyName, propertyValueSet, getItemFilter(b), getItemValue(b), valueComparer);
            if (aValid && !bValid) {
                return -1;
            }
            if (!aValid && bValid) {
                return 1;
            }
        }
        // return a.sortNo - b.sortNo;
        return itemComparer(a, b);
    });
    // Get selected item
    var value = property_1.PropertyValueSet.getInteger(propertyName, propertyValueSet);
    var selectedValueItemOrUndefined = items.find(function (item) {
        var itemValue = getItemValue(item);
        return (itemValue && property_1.PropertyValue.getInteger(itemValue)) === value;
    });
    var selectedValueItem;
    if (!selectedValueItemOrUndefined) {
        // Add item for selected value, even tough it does not really exist, but we need to show it in the combobox
        selectedValueItem = getUndefinedValueItem();
        sortedItems = __spreadArray([selectedValueItem], sortedItems);
    }
    else {
        selectedValueItem = selectedValueItemOrUndefined;
    }
    return [selectedValueItem, sortedItems];
}
function getItemToolTip(options, itemFilter, itemValue) {
    var isItemValid = isValueItemValid(options.propertyName, options.propertyValueSet, itemFilter, itemValue, options.valueComparer);
    return isItemValid ? "" : options.filterPrettyPrint(itemFilter);
}
function getItemLabel(itemText, itemValue, isItemValid, showCodes) {
    if (itemValue === undefined || itemValue === null) {
        return "";
    }
    return (isItemValid ? "" : "✘ ") + itemText + (showCodes ? " (" + property_1.PropertyValue.toString(itemValue) + ") " : "");
}
function getItemValueAsString(itemValue) {
    return itemValue === undefined || itemValue === null ? "" : property_1.PropertyValue.toString(itemValue);
}
function isValueItemValid(propertyName, propertyValueSet, itemFilter, itemValue, comparer) {
    if (itemValue === undefined || itemValue === null) {
        return true;
    }
    var pvsToCheck = property_1.PropertyValueSet.set(propertyName, itemValue, propertyValueSet);
    if (!itemFilter) {
        return true;
    }
    return property_1.PropertyFilter.isValid(pvsToCheck, itemFilter, comparer);
}
function _doOnChange(newValue, onValueChange) {
    if (newValue === undefined || newValue === null) {
        onValueChange(undefined);
    }
    else {
        onValueChange(property_1.PropertyValue.create("integer", parseInt(newValue, 10)));
    }
}
function fillOptionsWithDefualts(options) {
    return __assign(__assign({}, options), { sortValidFirst: options.sortValidFirst || false, showCodes: options.showCodes || false, disabled: options.disabled || false, filterPrettyPrint: options.filterPrettyPrint || (function (f) { return property_1.PropertyFilter.toString(f); }), valueComparer: options.valueComparer || property_1.PropertyValue.defaultComparer, falseItemIndex: options.falseItemIndex || 0, trueItemIndex: options.trueItemIndex || 1, itemComparer: function () { return 0; } });
}
//# sourceMappingURL=use-discrete-property-selector.js.map